import React from "react";
import Deposit from "../../components/Wallet/Deposit/Deposit";

export default function DepositPage() {
  return (
    <Deposit/>
    );
}
